import CategoriasFinanceirasLista from '@/pages/financeiro/categorias/CategoriasFinanceirasLista';
import ContasFinanceirasLista from '@/pages/financeiro/contasfinanceiras/ContasFinanceirasLista';
import ContasPagarLista from '@/pages/financeiro/contaspagar/ContasPagarLista';
import ContasReceberLista from '@/pages/financeiro/contasreceber/ContasReceberLista';

export default [
  {
    path: '/financeiro/categorias',
    name: 'FinanceiroCategoriasLista',
    component: CategoriasFinanceirasLista,
    meta: { permissao: '' },
  },
  {
    path: '/financeiro/contas-financeiras',
    name: 'FinanceiroContasFinanceirasLista',
    component: ContasFinanceirasLista,
    meta: { permissao: '' },
  },
  {
    path: '/financeiro/contas-pagar',
    name: 'FinanceiroContasPagarLista',
    component: ContasPagarLista,
    meta: { permissao: '' },
  },
  {
    path: '/financeiro/contas-receber',
    name: 'FinanceiroContasReceberLista',
    component: ContasReceberLista,
    meta: { permissao: '' },
  },
];
